import { Route, Routes, useLocation } from 'react-router-dom';
import { Suspense, lazy, useEffect, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { Navigate } from 'react-router-dom';
import { getMyData } from './services/userService';
import UserContext from './configs/userContext';
import LaunchPad from './pages/launchpad';
import LaunchPadbank from './pages/launchpad-bank';
import HomePage from './pages/home/home';
import HomeCashPage from './pages/home-cash/home';
import HomeBankPage from './pages/home-bank/home';
const ChatPage = lazy(() => import('./pages/chat/chat'));
const ChatCashPage = lazy(() => import('./pages/chat-cash/chat'));
const ChatBankPage = lazy(() => import('./pages/chat-bank/chat'));
const AlertsPage = lazy(() => import('./pages/alerts/alerts'));
const AlertsCashPage = lazy(() => import('./pages/alerts-cash/alerts'));
const AlertsBankPage = lazy(() => import('./pages/alerts-bank/alerts'));
const FaqsPage = lazy(() => import('./pages/faqs/faqs'));
const NotFoundPage = lazy(() => import('./pages/not-found/not-found'));
const NoAccessPage = lazy(() => import('./pages/no-access/noAccess'));
const Admin = lazy(() => import('./admin'));

const Home = () => {
  const [user, setUser] = useState({});
  const [apiFailure, setApiFailure] = useState(false);
  const usercheck = Object.keys(user).length > 0;
  const location = useLocation();

  useEffect(() => {
    async function getUser() {
      try {
        const { data: auth } = await getMyData();
        setUser(auth);
        setApiFailure(false);
      } catch (err) {
        setApiFailure(true);
      }
    }
    getUser();
  }, []);

  //Below pages are accessible only for authenticated users
  const protectedpages = [
    {
      path: 'default',
      component: LaunchPad
    },
    {
      path: 'home',
      component: LaunchPad
    },
    {
      path: 'home-bank',
      component: LaunchPadbank
    },
    {
      path: 'home-cash',
      component: HomeCashPage
    },
    {
      path: 'home-bank',
      component: HomeBankPage
    },
    {
      path: 'chat',
      component: ChatPage
    },
    {
      path: 'chat-cash',
      component: ChatCashPage
    },
    {
      path: 'chat-bank',
      component: ChatBankPage
    },
    {
      path: 'alerts',
      component: AlertsPage
    },
    {
      path: 'alerts-cash',
      component: AlertsCashPage
    },
    {
      path: 'alerts-bank',
      component: AlertsBankPage
    },
    {
      path: 'faqs',
      component: FaqsPage
    },
    {
      path: 'admin/*',
      component: Admin
    }
  ];

  return (
    <UserContext.Provider value={user}>
      <Routes>
        <Route
          path='/noAccess'
          element={
            <Suspense fallback={<div></div>}>
              <NoAccessPage />
            </Suspense>
          }
        />
      </Routes>
      {usercheck && (
        <Routes>
          <Route path='/*'>
            {protectedpages.map((page, i) => {
              if (page.path === 'default') {
                return <Route key={i} index element={<page.component user={user} />} />;
              }
              return (
                <Route
                  key={i}
                  path={page.path}
                  element={
                    <Suspense fallback={<div></div>}>
                      <page.component user={user} page={page.path} />
                    </Suspense>
                  }
                />
              );
            })}
          </Route>
          <Route path='*' element={<NotFoundPage />} />
        </Routes>
      )}
      {/* Redirect to login on API failure, unless already on /noAccess */}
      {apiFailure && location.pathname !== '/noAccess' && (
        <Navigate to='/login' state={{ from: location }} />
      )}
    </UserContext.Provider>
  );
};

export default Home;
